import React, { useState, useEffect } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { useParams } from "react-router-dom";

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV


const Section = styled.div`
  ${tw`mt-10`};
  width: 95%;
  margin: auto;
`;

const Heading = tw.h2`text-2xl font-bold text-gray-900 mb-4`;
const LargeCard = tw.div`bg-white p-2`;
// const CardGrid = tw.div`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 mt-4`;
const CardGrid = tw.div`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-4`;
const Card = tw.div`
  bg-white 
  shadow-md 
  rounded-xl 
  p-4 
  flex 
  flex-col 
  items-center 
  text-center 
  transition 
  duration-300 
  ease-in-out 
  hover:shadow-xl 
  hover:-translate-y-1 
  cursor-pointer
`;

const Image = tw.img`w-24 h-24 object-cover rounded-full`;
const Description = tw.p`mt-2 text-gray-700 text-sm`;

const Title = styled.h2`
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 30px;
    mergin-left:30px;

    @media (max-width: 768px) {
       font-size: 18px;
       font-weight: bold;
    }
`;

const LocalCulture = ({ destinationId }) => {

  const [cultureInfo, setCultureInfo] = useState(null);

  useEffect(() => {
    const fetchCultureData = async () => {
      try {
        const response = await fetch(`${API_URL}/web/destinations/culture/?destid=${destinationId}`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();
        if (result.header.resCode === 200 && result.data.length > 0) {
          setCultureInfo(result.data);
        }
      } catch (error) {
        console.error("Error fetching culture data:", error);
      }
    };
    fetchCultureData();
  }, [destinationId]);


  return (
    <>
      <br /><br />
      {
        cultureInfo &&
        <Section>
          <Title>Food,Culture & Heritage</Title>
          <LargeCard>
            <CardGrid>
              {cultureInfo.map((item, index) => (
                <Card key={index}>
                  <Image src={item.image} alt={item.title} />
                  <h3 tw="text-lg font-bold mt-4">{item.title}</h3>
                  <Description>{item.description}</Description>
                </Card>
              ))}
            </CardGrid>
          </LargeCard>
        </Section>
      }
    </>
  );
};

export default LocalCulture;
